export const aboutData = {
    title: "Who I am",
    description1: "My name is Md. Ali Hossain. I am a front-end web developer based in Dhaka, Bangladesh.",
    description2: "I completed my BSc in CSE from Khulna University in January 2022. I am a fresh graduate who loves solving problems. I have spent the last five months working on web-based applications on the front-end using technologies such as HTML, CSS, JavaScript, React, NodeJs and MongoDB.  My field of Interest's are building new  Web Technologies and Products.",
    image: 1
}